<template>
  <div class="dialog_container">
    <el-dialog
      title="编辑车辆保险信息"
      :visible="dialogShow"
      width="405px"
      @close="dialogClose"
      top="15vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form
          ref="redactForm"
          class="add_staff_form"
          :model="redactForm"
          label-width="100px"
          :rules="redactRules"
        >
          <el-form-item label="保险类型：" prop="insuranceType">
            <el-select
              v-model="redactForm.insuranceType"
              placeholder="请选择保险类型"
            >
              <el-option
                v-for="item in insuranceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险单号：" prop="insuranceSn">
            <el-input
              placeholder="请输入保险单号"
              v-model="redactForm.insuranceSn"
            ></el-input>
          </el-form-item>
          <el-form-item label="保险公司：" prop="insuranceCompany">
            <el-input
              placeholder="请输入保险单号"
              v-model="redactForm.insuranceCompany"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始时间：" prop="startTimeStr">
            <el-date-picker
              v-model="redactForm.startTimeStr"
              type="date"
              placeholder="请选择始时间"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间：" prop="endTimeStr">
            <el-date-picker
              v-model="redactForm.endTimeStr"
              type="date"
              placeholder="请选择到期时间"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="责任限额：" prop="insuranceMoney">
            <el-input
              placeholder="请输入责任限额"
              v-model="redactForm.insuranceMoney"
              class="limit"
            ></el-input>
            <div class="yuan_shangchuan">元</div>
          </el-form-item>
          <el-form-item label="纸质保单：" class="upload_form_item">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="uploadFile"
            >
              <img v-if="redactForm.image" :src="imgHttp + redactForm.image" class="avatar" />
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <img
                v-else
                class="uploading_icon"
                src="../../../../../static/images/uploading_icon.png"
                alt=""
              />
            </el-upload>
            <!-- <div class="tishi">
              请上传格式为jpg、jpeg、gif、png、bmp且大小不超过5M的图片
            </div> -->
          </el-form-item>
        </el-form>
        <div class="hint_box">
          <div class="hint_placeholder"></div>
          <div class="hint_text">
            请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
import config from "@/utils/config";
export default {
  name: "",
  data() {
    return {
      redactForm: {},
      imgHttp: "",
      redactRules: {
        insuranceType: [
          { required: true, message: "请选择保险类型", trigger: "change" },
        ],
        insuranceSn: [
          { required: true, message: "请输入保险单号", trigger: "blur" },
        ],
        insuranceCompany: [
          { required: true, message: "请输入保险单号", trigger: "blur" },
        ],
        startTimeStr: [
          { required: true, message: "请选择始时间", trigger: "change" },
        ],
        endTimeStr: [
          { required: true, message: "请选择到期时间", trigger: "change" },
        ],
        insuranceMoney: [
          { required: true, message: "请输入责任限额", trigger: "blur" },
        ],
      },
      insuranceList: [],
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: Object,
    carId: Number,
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.imgHttp = config.baseUrl;
        this.redactForm = {
          carId: this.carId,
          endTimeStr: new Date(this.dialogData.endTime),
          id: this.dialogData.id,
          image: this.dialogData.image ? '/' + this.dialogData.image.split(this.imgHttp)[1] : '',
          insuranceCompany: this.dialogData.insuranceCompany,
          insuranceMoney: this.dialogData.insuranceMoney,
          insuranceSn: this.dialogData.insuranceSn,
          insuranceType: this.dialogData.insuranceTypeStr,
          startTimeStr: new Date(this.dialogData.startTime),
        };
        this.getSelect();
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.redactForm.startTimeStr = dateTransition(
          this.redactForm.startTimeStr
        );
        this.redactForm.endTimeStr = dateTransition(this.redactForm.endTimeStr);
        if(typeof this.redactForm.insuranceType == "string"){
          this.insuranceList.forEach(i=>{
            if(i.name == this.redactForm.insuranceType){
              this.redactForm.insuranceType = i.id
            }
          })
        }
        this.$http.updateInsurance(this.redactForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.redactForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    getSelect() {
      this.$http.getCarInsuranceSelect().then((res) => {
        if (res.code == 0) {
          this.insuranceList = res.data;
        } else {
          this.insuranceList = [];
        }
      });
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        this.redactForm.image= res.msg;
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf" ||
        file.type == "application/msword" ||
        file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document";;
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
/deep/.el-input__inner {
  width: 250px;
}
.hint_box {
  width: 100%;
  display: flex;
  .hint_placeholder {
    width: 100px;
  }
  .hint_text {
    width: 250px;
    font-size: 11px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9b9b9b;
  }
}
.limit {
  /deep/.el-form-item__content {
    display: flex;
  }
  /deep/.el-input__inner {
    width: 220px;
  }
}
.yuan_shangchuan {
  position: absolute;
  top: 0;
  right: 20px;
}
.baodan_img {
  /deep/.el-input__inner {
    width: 206px;
  }
}
.avatar-uploader {
    width: 250px;
    height: 128px;
    border-radius: 2px;
    border: 1px solid #d1d1d1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .uploading_icon {
      width: 66px;
      height: 66px;
      margin-top: 5px;
    }
    .avatar{
        width: 250px;
    height: 128px;
        margin-top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/redactInsuranceDate.vue